module.exports = __webpack_public_path__ + "static/img/067_TO8_1632_og.22d3548.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/067_TO8_1632_og.jpg
// module id = hO8d
// module chunks = 0